export const GET_EVENTTYPES_REQUEST = "GET_EVENTTYPES_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_EVENTTYPE = 'INSERT_EVENTTYPE'
export const DELETE_EVENTTYPE = 'DELETE_EVENTTYPE'